import styled from 'styled-components'

export const MessageListContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column-reverse;
    flex: 1;
    overflow: hidden;
`

export const Messages = styled.div`
    overflow-y: scroll;
`
